/**
 * ContentCommentsSheet
 *
 * Wrapper that shows the comments UI via SheetService.
 * Mirrors Flutter's CommentsBottomSheet entry point.
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService';
import { ContentCommentsContent } from './ContentCommentsContent';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';
import type { CommentInfoEntity } from '@/domain/entities/comment/commentInfoEntity';

export interface ShowContentCommentsSheetParams {
  media: UserMediaEntity;
  commentInfo?: CommentInfoEntity;
  container?: HTMLElement | string | null;
  screenKey?: string;
  fixedHeight?: string;
}

const show = ({
  media,
  commentInfo,
  container,
  screenKey,
  fixedHeight = '85dvh',
}: ShowContentCommentsSheetParams) => {
  SheetService.show({
    title: '',
    content: (
      <ContentCommentsContent
        media={media}
        commentInfo={commentInfo}
        screenKey={screenKey}
      />
    ),
    container,
    screenKey,
    fixedHeight,
    scrollable: false,
  });
};

export const ContentCommentsSheet = {
  show,
};
